import React from "react";
import LeftPaneGift from "./LeftPaneFuture";
import RightPaneGift from "./RightPaneFuture";

const FutureProjects = () => {
  return (
    <section className="portfolio">
      <LeftPaneGift />
      <RightPaneGift />
    </section>
  );
};

export default FutureProjects;
